import React from 'react';
import { Grid } from '@mui/material';
import CustomAccordion from '../ui/CustomAccordion';
import InfoField from './InfoField';

interface FieldConfig {
  id: string;
  name: string;
  displayName: string;
  fields: {
    ExpandedViewItemKey: { value: string };
    ExpandedViewItemLabel: { value: string };
  };
}

interface TrackingParametersProps {
  trackingParams: Record<string, any>;
  fieldConfigs?: FieldConfig[];
  headerText?: string;
}

const TrackingParametersSection: React.FC<TrackingParametersProps> = ({
  trackingParams,
  fieldConfigs,
  headerText,
}) => {
  const [expanded, setExpanded] = React.useState(false);

  // Default field configurations if not provided from Sitecore
  const defaultFields = [
    { key: 'utmSource', label: 'UTM Source' },
    { key: 'utmMedium', label: 'UTM Medium' },
    { key: 'utmCampaign', label: 'UTM Campaign' },
    { key: 'utmTerm', label: 'UTM Term' },
    { key: 'utmContent', label: 'UTM Content' },
    { key: 'sid', label: 'sID' },
    { key: 'psecId', label: 'psecID' },
    { key: 'gclid', label: 'GCLID' },
    { key: 'fbclid', label: 'FBCLID' },
    { key: 'atid', label: 'ATID' },
  ];

  const fields = fieldConfigs
    ? fieldConfigs.map((config) => ({
        key: config.fields.ExpandedViewItemKey.value,
        label: config.fields.ExpandedViewItemLabel.value,
      }))
    : defaultFields;

  const hasData =
    trackingParams &&
    Object.keys(trackingParams).length > 0 &&
    fields.some((field) => {
      const value = (trackingParams as any)[field.key];
      return value !== null && value !== undefined && value !== '';
    });

  if (!hasData) return null;

  return (
    <CustomAccordion
      title={headerText || 'Tracking Parameters'}
      expanded={expanded}
      onChange={() => setExpanded(!expanded)}
      sx={{
        mt: 1,
        '& .MuiAccordionSummary-root': {
          minHeight: '40px',
          py: 0.5,
        },
        '& .MuiAccordionSummary-root.Mui-expanded': {
          minHeight: '40px',
          py: 0.5,
        },
        '& .MuiAccordionSummary-content': {
          margin: '0 !important',
        },
        '& .MuiAccordionSummary-content.Mui-expanded': {
          margin: '0 !important',
        },
      }}
      detailsSx={{ py: 1, px: 2 }}
    >
      <Grid container spacing={1.5}>
        {fields.map((field, index) => {
          const value = trackingParams[field.key];
          return (
            <Grid item xs={12} sm={6} md={3} key={field.key || index}>
              <InfoField label={field.label} value={value} />
            </Grid>
          );
        })}
      </Grid>
    </CustomAccordion>
  );
};

export default TrackingParametersSection;
